import appConfig from '../../appConfig';

import {
  getBaseForeignApiNetworkConfig,
} from '../../common/network/apiUtils';

function cartApiFactory(storefrontApiClient) {
  const cartApi = {
    addToCart(params) {
      return storefrontApiClient.post('/addToCart', params, {
        timeout: appConfig.checkoutTimeoutInMilliseconds,
      });
    },

    getCartItemCount(params) {
      return storefrontApiClient.get(`${appConfig.checkoutUrl}/ayagina-gelsin/Cart/GetCartItemCount`, {
        ...getBaseForeignApiNetworkConfig(),
        params,
        timeout: appConfig.checkoutTimeoutInMilliseconds,
      });
    },
  };

  return cartApi;
}

export default cartApiFactory;
